import ACTIONS, { FETCH_STATUS } from '../app.constants';
import { FeeTypeList, InvoiceType, JournalEntry, JournalEntryList } from '../modules/accounting/types';

export const getInvoiceTypes = {
    pending: {
        type: ACTIONS.GET_INVOICE_TYPES.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: InvoiceType[]) => ({
        type: ACTIONS.GET_INVOICE_TYPES.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        payload: data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_INVOICE_TYPES.ERROR,
        status: FETCH_STATUS.ERROR,
        payload: error,
    }),
};

export const getInvoiceTypesBegin = () => {
    return {
        type: ACTIONS.GET_INVOICE_TYPES_BEGIN,
    };
};

export const getFeeTypes = {
    pending: {
        type: ACTIONS.GET_FEE_TYPES.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: FeeTypeList) => ({
        type: ACTIONS.GET_FEE_TYPES.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        payload: data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_FEE_TYPES.ERROR,
        status: FETCH_STATUS.ERROR,
        payload: error,
    }),
};

export const getFeeTypesBegin = () => {
    return {
        type: ACTIONS.GET_FEE_TYPES_BEGIN,
    };
};

export const getJournalEntries = {
    pending: {
        type: ACTIONS.GET_JOURNAL_ENTRIES.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: JournalEntryList) => ({
        type: ACTIONS.GET_JOURNAL_ENTRIES.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        payload: data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_JOURNAL_ENTRIES.ERROR,
        status: FETCH_STATUS.ERROR,
        payload: error,
    }),
};

export const getJournalEntriesBegin = (params?: Record<string, unknown>) => ({
    type: ACTIONS.GET_JOURNAL_ENTRIES_BEGIN,
    payload: { params },
});

export const addJournalEntry = {
    pending: {
        type: ACTIONS.ADD_JOURNAL_ENTRY.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: {
        type: ACTIONS.ADD_JOURNAL_ENTRY.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
    },
    error: (error: Error) => ({
        type: ACTIONS.ADD_JOURNAL_ENTRY.ERROR,
        status: FETCH_STATUS.ERROR,
        payload: error,
    }),
};

export const addLineItems = {
    pending: {
        type: ACTIONS.ADD_LINE_ITEMS.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: {
        type: ACTIONS.ADD_LINE_ITEMS.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
    },
    error: (error: Error) => ({
        type: ACTIONS.ADD_LINE_ITEMS.ERROR,
        status: FETCH_STATUS.ERROR,
        payload: error,
    }),
};

export const voidInvoice = {
    pending: {
        type: ACTIONS.VOID_INVOICE.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: {
        type: ACTIONS.VOID_INVOICE.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
    },
    error: (error: Error) => ({
        type: ACTIONS.VOID_INVOICE.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const downloadInvoices = {
    pending: {
        type: ACTIONS.DOWNLOAD_INVOICE.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: {
        type: ACTIONS.DOWNLOAD_INVOICE.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
    },
    error: (error: Error) => ({
        type: ACTIONS.DOWNLOAD_INVOICE.ERROR,
        status: FETCH_STATUS.ERROR,
        payload: error,
    }),
};

export const addJournalEntryBegin = (journalEntry: JournalEntry) => {
    return {
        type: ACTIONS.ADD_JOURNAL_ENTRY_BEGIN,
        payload: journalEntry,
    };
};

export const addLineItemsBegin = (invoiceId: string, lineItems: []) => {
    return {
        type: ACTIONS.ADD_LINE_ITEMS_BEGIN,
        payload: { invoiceId, lineItems },
    };
};

export const voidInvoiceBegin = (invoiceId: string, licenseId: string, personId: string) => {
    return {
        type: ACTIONS.VOID_INVOICE_BEGIN,
        payload: { invoiceId, licenseId, personId },
    };
};

export const downloadInvoicesBegin = (invoiceId: string, invoiceTypeId: string, fileName: string) => {
    return {
        type: ACTIONS.DOWNLOAD_INVOICE_BEGIN,
        payload: { invoiceId, invoiceTypeId, fileName },
    };
};
